import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import FarmerDashboard from './FarmerDashboard';
import AgroDealerDashboard from './AgroDealerDashboard';
import { Navigate } from 'react-router-dom';

const DashboardRouter: React.FC = () => {
  const { user } = useAuth();

  if (user?.role === 'agro_dealer') {
    return <AgroDealerDashboard />;
  }

  if (user?.role === 'farmer') {
    return <FarmerDashboard />;
  }

  return <Navigate to="/marketplace" replace />;
};

export default DashboardRouter;
